function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function stepClass(n) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (state === n) {
    return 'step current';
  }
  if (state > n) {
    return 'step complete';
  }
  return 'step upcoming';
}
function stepButton(_ref) {
  var action = _ref.action,
    label = _ref.label,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled;
  if (!action) {
    return '';
  }
  var disabled = enabled ? '' : ' disabled';
  return "<button type=\"button\" class=\"saito-button-primary\" data-action=\"".concat(action, "\"").concat(disabled, ">").concat(label, "</button>");
}
function storeAddress() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$store_url = _ref2.store_url,
    store_url = _ref2$store_url === void 0 ? '' : _ref2$store_url;
  var url = escapeHtml(store_url);
  if (!url) {
    return '';
  }
  return "\n    <div class=\"store-address\">\n      <p class=\"label\">Your store address</p>\n      <div class=\"storefront-url-row\">\n        <a class=\"storefront-url\" data-storefront-url href=\"".concat(url, "\" title=\"").concat(url, "\">").concat(url, "</a>\n        <button type=\"button\" class=\"saito-icon-button\" data-action=\"copy-url\" title=\"Copy storefront URL\" aria-label=\"Copy storefront URL\">\n          <i class=\"fas fa-copy\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n    </div>\n  ");
}
module.exports = {
  overlay: function overlay() {
    return "\n    <div class=\"prepare-store preparing\">\n      <header>\n        <div class=\"heading\">\n          <h2 data-prepare-title>Preparing your store</h2>\n          <p class=\"lede\" data-prepare-lede hidden>You can now list NFTs and other digital assets for sale or rent.</p>\n        </div>\n      </header>\n      <div class=\"body\">\n        <div class=\"preparing-panel\">\n          <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n          <p class=\"status\" data-prepare-status>Checking store URL</p>\n        </div>\n        <div class=\"ready-panel\" hidden></div>\n      </div>\n    </div>\n    ";
  },
  ready: function ready() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$state = _ref3.state,
      state = _ref3$state === void 0 ? 1 : _ref3$state,
      _ref3$actions = _ref3.actions,
      actions = _ref3$actions === void 0 ? {} : _ref3$actions,
      _ref3$store_url = _ref3.store_url,
      store_url = _ref3$store_url === void 0 ? '' : _ref3$store_url,
      _ref3$awaiting_mint = _ref3.awaiting_mint,
      awaiting_mint = _ref3$awaiting_mint === void 0 ? false : _ref3$awaiting_mint;
    var step2Copy = awaiting_mint ? 'Waiting for your NFT to confirm on the network...' : 'Create an NFT or upload media to list and sell.';
    var createEnabled = !!actions.create_nft && state === 2 && !awaiting_mint;
    return "\n      <ol class=\"steps\" data-state=\"".concat(state, "\">\n        <li class=\"").concat(stepClass(1, state), "\" data-step=\"1\">\n          <div class=\"index\" aria-hidden=\"true\">1</div>\n          <div class=\"figure\">\n            <span class=\"disc\" aria-hidden=\"true\"></span>\n            <img src=\"/store/img/store-wizard-plant-1.png\" alt=\"\">\n          </div>\n          <p class=\"copy\">You'll need SAITO to create and list digital assets.</p>\n          ").concat(stepButton({
      action: actions.get_saito && 'get-saito',
      label: 'GET SAITO',
      enabled: !!actions.get_saito && state === 1
    }), "\n        </li>\n        <li class=\"").concat(stepClass(2, state), "\" data-step=\"2\">\n          <div class=\"index\" aria-hidden=\"true\">2</div>\n          <div class=\"figure\">\n            <span class=\"disc\" aria-hidden=\"true\"></span>\n            <img src=\"/store/img/store-wizard-plant-2.png\" alt=\"\">\n          </div>\n          <p class=\"copy\">").concat(step2Copy, "</p>\n          ").concat(stepButton({
      action: actions.create_nft && 'create-nft',
      label: 'CREATE NFT',
      enabled: createEnabled
    }), "\n        </li>\n        <li class=\"").concat(stepClass(3, state), "\" data-step=\"3\">\n          <div class=\"index\" aria-hidden=\"true\">3</div>\n          <div class=\"figure\">\n            <span class=\"disc\" aria-hidden=\"true\"></span>\n            <img src=\"/store/img/store-wizard-plant-3.png\" alt=\"\">\n          </div>\n          <p class=\"copy\">List your NFT or media on your Store.</p>\n          ").concat(stepButton({
      action: actions.list_item && 'list-item',
      label: 'LIST ON STORE',
      enabled: !!actions.list_item && state === 3
    }), "\n        </li>\n      </ol>\n      ").concat(storeAddress({
      store_url: store_url
    }), "\n    ");
  }
};